import { Buttons } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';

const EmailButton = ({ onClick }: { onClick: () => void }): JSX.Element => {
  const { t } = useTranslation(locizeNS.AUTH);
  return (
    <Buttons.Classic
      size="l"
      label={t(`SignIn.email`)}
      mode="secondary"
      onClick={onClick}
      className="btn-social"
      data-testid="email-button"
      iconStart="IconEmailM"
    />
  );
};

export default EmailButton;
